export interface IdpDataLayer {
  dataLayer: {
    digitalData: {
      attributes: {
        cardBanner: {
          applicationStatus: string;
          cardType: string;
          offerId: string;
        };
        siteSearch: {
          header: string;
          page: string;
          footer: string;
        };
      };
      page: {
        pageInfo: {
          pageID: string;
        };
      };
    };
  };
}

export interface AnalyticsEvent {
  name: string;
  value: string;
}

export interface AdobeDataLayer {
  event_detail: string;
  event: string;
  page?: AnalyticsPage;
  click?: AnalyticsClick;
  user?: AnalyticsUser;
  error?: AnalyticsError;
  site_assets?: AnalyticsSiteAssets[];
  form?: AnalyticsForm[];
}

export interface AnalyticsClick {
  name: string;
  component_type?: string;
  component_name?: string;
  type: string;
  page_section: string;
  action: string;
}
export interface AnalyticsUser {
  attributes: AnalyticsUserAttributes;
  profile?: AnalyticsProfile;
}
export interface AnalyticsProfile {
  skymiles_number: string;
  skymiles_tier: string;
  amex_card_type: string;
  available_miles: string;
  email: string;
  email_domain?: string;
  encrypted_email?: string;
  company_name?: string;
}
export interface AnalyticsUserAttributes {
  is_logged_in: string;
  login_method?: string;
  login_state?: string;
}

export interface AnalyticsPage {
  info: AnalyticsPageInfo;
}
export interface AnalyticsPageInfo {
  legacy_page_name: string;
  page_name: string;
  page_url: string;
  page_type: string;
  previous_page_name?: string;
  previous_page_url?: string;
  section?: string;
  sub_section?: string;
  country?: string;
  language?: string;
  sys_env?: string;
  page_load_time: number;
}

export interface AnalyticsError {
  type?: string;
  code: string;
  message: string;
}

export interface AnalyticsSiteAssets {
  type: string;
  position: string;
  name: string;
  fare_class?: string;
  cabin_name?: string;
  sub_type?: string;
  price_difference?: string;
  value?: string;
  miles?: string;
  fare_type?: string;
  currency_code?: string;
  source?: string;
}

export interface AnalyticsForm {
  name: string;
  type: string;
  step_name: string;
  step_num: number;
}

export type AdobeAnalyticsEvent = 'event' | 'event_detail';

export type PageLoadAnalytics = Required<
  Pick<AdobeDataLayer, AdobeAnalyticsEvent | 'page' | 'user' | 'site_assets'>
>;

export type PageLoadErrorAnalytics = Required<
  Pick<AdobeDataLayer, AdobeAnalyticsEvent | 'page' | 'user' | 'error'>
>;

export type ClickEventAnalytics = Required<
  Pick<AdobeDataLayer, AdobeAnalyticsEvent | 'click' | 'user'>
> &
  Pick<AdobeDataLayer, 'error'>;

export type FormEventAnalytics = Required<
  Pick<AdobeDataLayer, AdobeAnalyticsEvent | 'form'>
> &
  Pick<AdobeDataLayer, 'user'>;
